import { get, find, concat, map, toUpper, filter, startsWith, toLower } from "lodash"
import { createSelector } from "reselect"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { getModels } from "resources/models"
import { getSwapsWithMeta } from "./swaps"
import { getWatchlistsWithMeta } from "./watchlists"
import { getTopicsWithMeta } from "./topics"
import { getPortfoliosWithMeta } from "./portfolios"

const EMPTY_ARRAY = []

const getRawSelectedModel = state => get(state, "modules.resources.selectedModel")
export const getFavoritesScreen = (_, props) => get(props, "favorites", null)
const getForecasts = state => get(state, "global.data.forecasts.data.forecasts")

const getRawRecentResources = state => get(state, "modules.resources.recentResources", EMPTY_ARRAY)

export const getResources = createSelector(
  [getSwapsWithMeta, getTopicsWithMeta, getWatchlistsWithMeta, getPortfoliosWithMeta],
  (swaps, topics, watchlists, portfolios) => concat(swaps, topics, watchlists, portfolios),
)

export const getRecentResources = createSelector(
  [getRawRecentResources, getResources],
  (recentResources, resources) => map(recentResources, resource => find(resources, ({ id, alias }) => resource.type === "swap" ? toUpper(resource.alias) === toUpper(alias) : resource.id === id)),
)

const getMostUsedModelOrDefault = createSelector(
  [getPortfoliosWithMeta, getModels],
  getMostUsedOrDefaultModelId,
)

export const getModel = createSelector(
  [getMostUsedModelOrDefault, getRawSelectedModel],
  (mostUsedModelOrDefault, selectedModel) => selectedModel || mostUsedModelOrDefault,
)

// This selector is used to prevent editing the name of a portfolio linked to an Alpha Theory forecast
// TODO: Replace this with relatedResource logic when implemented
export function filterATForecasts(forecasts) {
  return filter(forecasts, ({ name }) => startsWith(toLower(name), "at pwr"))
}

export const getATForecasts = createSelector(
  [getForecasts],
  filterATForecasts,
)
